import React from 'react';
import { Button } from '@mui/material';

interface RevitParameterCatalogActionProps {
  disabled: boolean;
  isLoading: boolean;
  onLoad: () => void;
}

const RevitParameterCatalogAction: React.FC<RevitParameterCatalogActionProps> = ({
  disabled,
  isLoading,
  onLoad,
}) => (
  <Button
    size="small"
    variant="outlined"
    disabled={disabled || isLoading}
    onClick={onLoad}
  >
    {isLoading ? 'Reading Revit parameters…' : 'Refresh Revit parameter list'}
  </Button>
);

export default RevitParameterCatalogAction;
